import React, { useState } from 'react';
import { Platform, View } from 'react-native';
import { usesStoreBilling } from '@/lib/appDistribution';
import Text from '@/components/Typography/Text';
import Button from '@/components/Buttons/Button';

export default function AppStoreCatalogStatus({ iap, credits = false }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const products = credits ? iap?.creditPackProducts : iap?.products;
  const storeName = Platform.OS === 'android' ? 'Google Play' : 'App Store';
  if (!usesStoreBilling() || (products?.length && !iap?.error && !error && !iap?.purchasePending)) return null;
  const reload = async () => {
    if (busy) return;
    setBusy(true); setError('');
    try {
      if (!iap?.isConnected && !await iap?.connect()) throw new Error(`${storeName} is unavailable.`);
      const result = await iap.fetchProducts();
      if (!(credits ? result?.creditPacks : result?.subscriptions)?.length) throw new Error(`${storeName} prices are unavailable. Please try again.`);
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  const restore = async () => {
    if (busy) return;
    setBusy(true); setError('');
    try {
      const result = await iap?.restorePurchases?.();
      if (!result?.success) setError(result?.error || 'Purchases are still being verified. Please try Restore again; do not purchase again.');
    } catch (_) { setError('Unable to check purchases. Please try Restore again; do not purchase again.'); }
    finally { setBusy(false); }
  };
  return <View style={{ gap: 8, paddingVertical: 12 }}>
    <Text size="s" color="secondary" accessibilityRole="alert">{iap?.purchasePending
      ? error || 'Your purchase is still being verified. Use Restore; do not purchase again.'
      : error || iap?.error || `Loading ${storeName} prices…`}</Text>
    {iap?.purchasePending
      ? <Button text="Restore purchases" variant="secondary" size="small" isLoading={busy} onPress={restore} />
      : <Button text={`Reload ${storeName} prices`} variant="secondary" size="small" isLoading={busy} onPress={reload} />}
  </View>;
}
